import {z} from 'zod';


export const b2bCalendarTimeInterval = z.object({
  id: z.coerce.number(),
  startTime: z.coerce.string().time(),
  endTime: z.coerce.string().time(),
});

export type b2bCalendarTimeInterval = z.infer<typeof b2bCalendarTimeInterval>;

